import { WorkflowDefinition, TaskType } from '../types/architectureTask';

export const WORKFLOWS: Record<TaskType, WorkflowDefinition> = {
    STYLE_TRANSFORMER: {
        id: 'STYLE_TRANSFORMER',
        label: 'Style Transformer',
        steps: [
            { id: 'upload', label: 'Upload Elevation' },
            { id: 'configure', label: 'Select Style' },
            { id: 'generate', label: 'Generate' }
        ]
    },
    PLAN_TO_ELEVATION: {
        id: 'PLAN_TO_ELEVATION',
        label: 'Plan to Elevation',
        steps: [
            { id: 'upload_gf', label: 'Ground Floor' },
            { id: 'upload_typ', label: 'Typical Floor' },
            { id: 'specs', label: 'Building Specs' },
            { id: 'generate', label: 'Generate Model' }
        ]
    },
    INPAINTING: {
        id: 'INPAINTING',
        label: 'Magic Lasso',
        steps: [
            { id: 'select', label: 'Select Area' },
            { id: 'prompt', label: 'Describe Change' },
            { id: 'generate', label: 'Refine' }
        ]
    },
    INTERIOR_DESIGN: {
        id: 'INTERIOR_DESIGN',
        label: 'Interior Design',
        steps: [
            { id: 'upload', label: 'Upload Room' },
            { id: 'style', label: 'Choose Style' },
            { id: 'generate', label: 'Redesign' }
        ]
    }
};

export const DEFAULT_TASK_TYPE: TaskType = 'STYLE_TRANSFORMER';
